import { type ChatConfigResponse } from '@myre/app-agent-generated/types/ChatConfigResponse';
import { type ISelectItem } from '@myre/ui-primitive-forms';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  input,
  Output,
} from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';

import { ChatWindowService } from '../../chat/chat-window.service';
import { ChatService } from '../../chat/chat.service';
import { ChatFooterBarComponent } from '../../chat/components/chat-footer-bar/chat-footer-bar.component';
import { ChatWindowComponent } from '../../chat/components/chat-window/chat-window.component';

import { MenuService } from './menu/menu.service';
import { MyreHeaderComponent } from './myre-header/myre-header.component';
import { MyreSideNavComponent } from './myre-side-nav/myre-side-nav.component';

@Component({
  selector: 'myre-app',
  templateUrl: './myre-app.component.html',
  styleUrls: ['./myre-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatSidenavModule,
    MyreSideNavComponent,
    MyreHeaderComponent,
    RouterOutlet,
    ChatWindowComponent,
    ChatFooterBarComponent,
  ],
})
export class MyreAppComponent<T> {
  @Input({
    required: true,
  })
  public auth$: (jwt?: string) => Observable<boolean>;

  public searchResults = input<ISelectItem<T>[]>();

  /**
   * Chat API configuration override (agents, greetingMessage, footer).
   * If not provided, the chat component fetches config from ChatConfigResponse.
   */
  public chatApiConfig = input<ChatConfigResponse>();

  /**
   * Chat welcome screen icon URL (displayed above greeting message)
   */
  public chatWelcomeIconUrl = input<string>();

  /**
   * Chat welcome screen icon emoji fallback
   */
  public chatWelcomeIcon = input<string>();

  @Output()
  public searchUserInput = new EventEmitter<string>();

  @Output()
  public searchItemClicked = new EventEmitter<T>();

  protected readonly _menuService = inject(MenuService);
  protected readonly _chatService = inject(ChatService);
  protected readonly _chatWindowService = inject(ChatWindowService);
}
